module.exports = __webpack_public_path__ + "static/mentor-bhavish_s-a8cb952e514ea346da1454b789c78716.jpg";